'use es6';

import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UILink from 'UIComponents/link/UILink';
import useDashboardLimit from '../../access/limits/hooks/useDashboardLimit';
import { useHasReportingCreateAndOwnAccess } from '../../access/scopes/hooks/useHasScope';
import useUserInfo from '../../access/useUserInfo';
import { useDashboards } from '../../data/hooks/useDashboards';
import { getUpgradeUrl } from '../../lib/linkUrls';
import { INSUFFICIENT_REPORTING_PERMISSION_LEVEL, WILL_EXCEED_DASHBOARD_LIMIT } from '../problems';
import { DATA_FETCHING_ERROR_PROBLEM_AND_MESSAGE, LOADING_PROBLEM_AND_MESSAGE } from '../shared/dataProblemsAndMessages';
import { useDashboardLimitUpgradeKey } from '../shared/upgradePoints/upgradePointKeys';

//TODO: accept dashboard/widgets and check whether creating those will put the portal over custom or standard report limit
import { jsx as _jsx } from "react/jsx-runtime";
const useCreateDashboardProblem = ({
  upgradeLocation
} = {}) => {
  const hasReportingCreateAndOwnAccess = useHasReportingCreateAndOwnAccess();
  const {
    loading: userInfoLoading,
    error: userInfoError
  } = useUserInfo(false);
  const {
    data: dashboardsData,
    loading: dashboardsLoading,
    error: dashboardsLoadingError
  } = useDashboards();
  const dashboardLimit = useDashboardLimit();
  const dashboardLimitUpgradeKey = useDashboardLimitUpgradeKey(upgradeLocation);
  if (userInfoLoading || dashboardsLoading) {
    return LOADING_PROBLEM_AND_MESSAGE;
  }
  if (userInfoError || dashboardsLoadingError) {
    return DATA_FETCHING_ERROR_PROBLEM_AND_MESSAGE;
  }
  if (!hasReportingCreateAndOwnAccess) {
    return {
      problem: INSUFFICIENT_REPORTING_PERMISSION_LEVEL,
      disabledMessage: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "reporting-action-components.actions.createDashboard.button.tooltip.insufficientReportingPermission"
      })
    };
  }
  if (dashboardsData && dashboardsData.get('allDashboards') >= dashboardLimit) {
    return {
      problem: WILL_EXCEED_DASHBOARD_LIMIT,
      disabledMessage: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "reporting-action-components.actions.createDashboard.button.tooltip.willExceedDashboardLimit_jsx",
        options: {
          limit: dashboardLimit,
          href: getUpgradeUrl()
        },
        elements: {
          UILink
        }
      }),
      upgradeKey: dashboardLimitUpgradeKey
    };
  }
  return {
    problem: null,
    disabledMessage: null
  };
};
export default useCreateDashboardProblem;